import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import cs from "./locales/cs.json";
import sk from "./locales/sk.json";
import de from "./locales/de.json";
import hr from "./locales/hr.json";
import pl from "./locales/pl.json";

// Available languages. Add a new locale JSON + entry here to support it.
const resources = {
  cs: { translation: cs },
  sk: { translation: sk },
  de: { translation: de },
  hr: { translation: hr },
  pl: { translation: pl },
};

// Each domain/deployment serves exactly ONE language, fixed at build time via
// the REACT_APP_LANGUAGE env var (e.g. sk.prihoriva → REACT_APP_LANGUAGE=sk).
// The language never changes at runtime, so there is no flash on reload.
const DEFAULT_LANGUAGE = "cs";
const BUILD_LANGUAGE =
  resources[process.env.REACT_APP_LANGUAGE] != null
    ? process.env.REACT_APP_LANGUAGE
    : DEFAULT_LANGUAGE;

// pl, hr a de jsou samostatné trhy (15. 10. 2026): chybějící text se tam NEsmí
// nahradit češtinou. Úplnost hlídá App.separatemarkets.test.js. cs a sk dál
// padají na češtinu (slovenština nemá české funkce jako Anočine přeložené).
export const SEPARATE_MARKETS = ["pl", "hr", "de"];

i18n.use(initReactI18next).init({
  resources,
  lng: BUILD_LANGUAGE,
  fallbackLng: SEPARATE_MARKETS.includes(BUILD_LANGUAGE) ? false : DEFAULT_LANGUAGE,
  // Flat keys with dots (e.g. "buttons.login"); do not treat dots/colons as
  // separators so keys map 1:1 to the locale JSON.
  keySeparator: false,
  nsSeparator: false,
  interpolation: {
    escapeValue: false, // React already escapes values
  },
  returnEmptyString: false,
});

/**
 * Sync the browser tab title (document.title) with the active language.
 */
export function updateDocumentTitle() {
  const title = i18n.t("meta.pageTitle");
  if (title && typeof document !== "undefined") {
    document.title = title;
  }
}

// Set the tab title once for the fixed build-time language.
updateDocumentTitle();

export default i18n;
